import MaterialUIChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import * as React from "react";
export function ChevronLeftIcon() {
    return <MaterialUIChevronLeftIcon />;
}
